/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:31:45
 */
export default {
  lang: "英语",
  landing: {
    name1: "Buksan ang Carlcare",
    name2: "Gumawa ng reserbasyon",
    name3: "Sa Carlcare, maaari mong tingnan ang iyong order anumang oras.",
    name4: "",
    name5: "Mag-slide pakanan",
    name6: "Natapos na ang pag-verify",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from ₱500, you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    // name16: "Lower and Transparent Pricing",
    // name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy a 3-month warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. If you join the flat price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.",
    name31: "Carlcare Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Pumil ing modelo ng device",
    name2: "Paglalarawan sa Problema:",
    name3: "Tapikin para piliin ang tindahan ng serbisyo",
    name4: "Tindahan ng Serbisyo:",
    name5: "Oras ng Reserbasyon:",
    name6: "Mangyaring ilarawan nang may detalye ang problema ng yong device!",
    name7: "Tapikin para pumili ng oras ng pagdating",
    name8: "Mangyaring ilagay ang tamang detalye sa pagkontak upang makausap ka namin",
    name9: "Ang available na oras ng reserbasyon ay ang mga sumusunod:",
    name10: "Mangyaring ipasok ang numero ng iyong telepono",
    name11: "Presyo",
    name12: "Personal na Impormasyon:",
    name13: "Pakilagay ang iyong pangalan",
    name14: "Isumite",
    name15: "Kanselahin",
    name16: "OK",
  },
  shops: {
    name1: "Batay sa brand na pinili mo, ang sumusunod na mga tindahan ay makakapaglingkod sa iyo!",
    name2: "Manatiling nakatutok! Darating sa mas marami pang mga retail store!",
  },
  price: {
    name1: "Tatak",
    name2: "Modelo",
    name3: "ITEM",
    name4: "Presyo",
    name5: "Taos pusong Paalala:",
    name6: "Ang mga presyong iyo ay bilang sanggunian lamang, ang aktwal na presyo ay ayon sa kondisyon ng iyong device.",
    name7: "Kung walang ispesyal na simbolo, ang presyo ng unit ay sa lokal na salapi.",
    name8: "Paumanhin! Walang impormasyon sa presyo na mahanap sa iyong kasalukyang rehiyon.",
    name11:"Gastos sa Trabaho",
    name12:"Kabuuang Presyo",
    name13: "5. Kung ang gastos sa labor ay \"/\", kailangang ipaalam sa store ang gastos na ito.",
    item_main_board: "Mainboard",
    item_screen_frame: "Screen (Frame)",
    item_screen_screen_frame: "Pangalawang Screen (Frame)",
    item_touch_screen: "Touch Screen",
    item_camera: "Kamera",
    item_fixed_focus_camera: "Fixed Focus Camera",
    item_auto_focus_camera: "Auto Focus Camera",
    item_screen: "Screen",
    item_secondary_screen: "Pangalawang Screen",
    item_fingerprint_module: "Fingerprint Module",
    item_speaker: "Speaker",
    item_receiver: "Tatanggap",
    item_small_board: "Maliit na Board",
    item_battery_cover: "Takip ng Baterya",
    item_battery: "Baterya",
    item_charger: "Charger",
    item_usb_cable: "USB Cable",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Walang Data",
    name2: "Provider ng Serbisyo:",
    name3: "Brand ng Serbisyo:",
    name4: "Telepono:",
    name5: "Dami ng Order:",
    name6: "Rating ng Serbisyo",
    name7: "Kapaligiran ng Serbisyo:",
    name8: "Pag-uugali ng Serbisyo:",
    name9: "Kabisaan ng Serbisyo:",
    name10: "Kalidad ng Serbisyo:",
    name11: "Ebalwasyon ng Kustomer",
    name12:"hanggang",
    name13:"Isinara",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Buksan ang Carlcare",
    name1: "Mangyaring kumuha ng screenshot ng impormasyon ng reserbasyon at i-save ito bilang resibo para maakses ang prayoridad na serbisyo.",
    name2: "Matagumpay na naisumite",
    name3: "1. Linisin ang datos",
    name4: "Mangyaring i-back up ang mga importanteng pribadong datos sa iyong telepono bago gawin",
    name5: "2. Huwag paganahin ang password sa pag-power-on",
    name6: "Bagong magpunta sa tindahan ng serbisyo, mangyaring",
    name7: "Tindahan ng Serbisyo",
    name8: "Oras ng Reserbasyon",
    name9: "Paglalarawan sa Problema",
    name10: "Modelo ng Device",
    name11: "Numero ng Order",
    name12: "Impormasyon ng Order",
  },
  title: {
    
    name1: "Sinusuportahan ang mga sumusunod na mga bansa:",
    name2: "Pumili ng Modelo",
    name3: "Reserbasyon",
    name4: "Mga Detalye ng Serbisyo ng Tindahan",
    name5: "Pumili ng Tindahan ng Serbisyo",
  },
  error: {
    
    name1: "Walang datos. Mangyaring tinginan ang impormasyon sa pagkumpuni",
    name2: "Kailangan pa ng tulong?Kontakin kami.",
    name3: "Paumanhin. Walang Carlcare center sa iyong kasalukuyang rehiyon.",
    name4: "Mangyaring piliin muna ang service center",
    name5: "Nabigo",
    name6: "Mangyaring piliin muna ang modelo ng device",
    name7: "Mga Detalye",
    name8: "Mangyaring ilarawan nang may detalye ang iyong kailangan",
    name9: "",
  },
  add1:{
    "name0": "tl",
    "name1": "Nakumpirma ang iyong order. Inaasahan namin ang iyong pagdating.",
    "name2": "Piliin ang lungson",
    "name3": "Pakilagay ang numero ng telepono na may %1$s mga digit.",
    "name4": "Mga Oras ng Araw ng Linggo",
    "name5": "Lunes",
    "name6": "Martes",
    "name7": "Miyerkules",
    "name8": "Huwebes",
    "name9": "Biyernes",
    "name10": "Sabado",
    "name11": "Linggo",
    "name12": "Ilagay ang bansa at maghanap"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Iba pa",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"I-tap para Ma-redirect",
    name3:"Buksan ang Carlcare app para i-rate ang order",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Pumili ng Serbisyo",
    name7:"Libreng Pag-clean up",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Mali ang impo",
    "cancelReason1": "Hindi makakarating sa oras",
    "cancelReason2": "Magkatulad na order/hindi ko order",
    "cancelReason3": "Hindi nagkakaroon ng pagkasira",
    "cancelReason4": "Para lamang sa pagsusuri/pagsisiyasat/kaganapan/…",
    "cancelReason5": "Mahal",
    "cancelReason6": "Kakulangan ng mga materyal",
    "cancelReason7": "Walang pagkakaiba sa mga serbisyo",
    "cancelReason8": "Ang tindahan ay masyadong malayo",
    "cancelReason9": "Ang tindahan ay sarado",
    "cancelReason10": "Pangit ang ugali sa paglilingkod",
    "cancelReason11": "Pagpapalit/pagkukumpuni para sa ibang tatak",
    "cancelReason12": "Hindi mahanap ang tindahan",
    "cancelReason13": "Iba pa",
    "cancelOrder": "Kanselahin ang Order",
    "reason_dialog_title": "Pakisabi sa amin ang dahilan ng pagkansela",
    "Cancel": "Kanselahin",
    "OK": "OK",
    "name1": "ipasok ang verification code",
    "name2": "Maling code ng beripikasyon",
    "repair_reservation_detail_canceled": "Nakansela na ang order na ito!",
    "purchase_cancel_dialog_content": "Kinukumpirma mo bang kakanselahin ang order?",
    "yes": "Ipakita",
    "no": "Huwag ipakita"
}
};
